import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ContentVideoListItem } from "../../content.types";
import { requestUpdateVideo } from "./updateVideo.request";

const useUpdateVideo = (
  options?: MutationOptions<ContentVideoListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateVideo,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateVideo;
